<script>
	import styles from './Nav.module.css';
</script>

<li class={styles.divider} role="presentation" />
